<template>
  <div
    :class="$style['header']"
    class="columns"
  >
    <div class="column">
      <slot name="left" />
    </div>
    <div :class="$style['right']">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DsContentHeader"
};
</script>

<style lang="scss" module>
@import "../../scss/_mixins.scss";

.header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px !important;
  margin-right: 0px !important;
  @include mobile() {
    flex-direction: column;
  }
  div:first-child {
    align-self: flex-start;
    // padding-bottom: 0px;
  }
}
.right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @include mobile() {
    justify-content: center;
    // margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-content-header.vue